import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';
import color from '@decisiv/design-tokens/lib/color';

import KDSBreadcrumbs from '@decisiv/ui-components/lib/components/Breadcrumbs';
import Flex from '@decisiv/ui-components/lib/components/Flex';

export const Root = styled(Flex)`
  flex: 1;
  flex-direction: column;

  overflow: hidden;
`;

export const EntityTabsContainer = styled(Flex).attrs({
  paddingX: 2,
  paddingY: 1,
  'data-testid': 'management-entity-tabs',
})`
  gap: ${rem(spacing.base * 0.5)};

  border-top: 1px solid ${toColorString(color.base.halfMoon)};
  border-bottom: 1px solid ${toColorString(color.base.halfMoon)};
`;

export const TabsContainer = styled(Flex).attrs({ marginTop: 1 })`
  flex: 1;

  overflow: hidden;

  & > div {
    flex: 1;

    &,
    & > :not(div:first-of-type) {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    & > div:first-of-type {
      margin-left: ${rem(spacing.base * 2)};
      margin-right: ${rem(spacing.base * 2)};
    }

    & > div[aria-hidden='true'] {
      display: none;
    }
  }
`;

type KDSBreadcrumbsProps = ExtractProps<typeof KDSBreadcrumbs>;

const BreadcrumbsContainer = styled(Flex).attrs({ padding: 1 })`
  background-color: ${toColorString(color.base.fullMoon)};
`;

export const Breadcrumbs = ({ ...rest }: KDSBreadcrumbsProps) => {
  return (
    <BreadcrumbsContainer>
      <KDSBreadcrumbs {...rest} />
    </BreadcrumbsContainer>
  );
};

export * as Header from './Header';
export * as TabBody from './TabBody';
